import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchReports(account, page, pageSize) {
    let url = `/Report/GetPDFByEmailAccountId/${encodeURIComponent(pageSize)}/${encodeURIComponent(page)}`;

    if (account) {
        url += '?';

        if (account) {
            url += `cAccountID=${encodeURIComponent(account)}`;
        }
    }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Reports found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Reports: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchPdf(id, path) {
    const url = `/Report/DisplayPDFImage?iPDFId=${encodeURIComponent(id)}&cFilePath=${encodeURIComponent(path)}`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            } else {
                throw new Error(`Failed to fetch Opticians: ${response.status} ${response.statusText}`);
            }
        }

        const blob = await response.blob();
        return blob;
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchSightTests(account, page, pageSize, searchValue = null) {
    let url = `/SightTest/GetSightTestHistory/${encodeURIComponent(pageSize)}/${encodeURIComponent(page)}`;

    if (account || searchValue) {
        url += '?';

        if (account) {
            url += `cAccountID=${encodeURIComponent(account)}`;
        }

        if (searchValue) {
            if (account) {
                url += '&';
            }
            url += `cSearchName=${encodeURIComponent(searchValue)}`;
        }
    }

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Sight Tests found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Sight Tests: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}